import { useCallback, useState } from "react";
import { listRequest } from "../../../../store/slices/usersSlice";

// The paging and sort the notification forms' pickers start from (the same
// values as usersSlice's own defaults), without any search term.
export const PICKER_BASE_QUERY = {
  pageNo: 1,
  pageSize: 50,
  sortBy: "asc",
  sortColumn: "firstName",
  namePattern: "",
};

// The Select Users dialog's own search state. It is kept here, not in
// usersSlice's query, which the admin Users screen reads: a term typed in the
// dialog must not carry over to that screen (E2E11). The API's user search is
// namePattern (first name, last name or email); without a term, fetchUsers
// keeps the one the dialog last set.
export const useUserPicker = (dispatch) => {
  const [query, setQuery] = useState(PICKER_BASE_QUERY);

  const fetchUsers = useCallback(
    (searchTerm = query.namePattern || "") => {
      dispatch(listRequest({ query: { ...query, namePattern: searchTerm } }));
    },
    [dispatch, query]
  );

  return { query, setQuery, fetchUsers };
};
